// extracted by mini-css-extract-plugin
module.exports = {"container":"_2PXGjRSLgZdyVqJo6wQ3Kw"};